/* eslint-disable react/display-name */
import { Select, selectClasses } from '@mui/base/Select';
import { Option, optionClasses } from '@mui/base/Option';
import { Popper } from '@mui/base';
import styled from '@mui/material/styles/styled';
import { cx } from 'cva';
import * as React from 'react';

// const StyledButton = styled('button')(
//   ({ theme }) => `
//   box-shadow: inset 0px 1px 5px #d0d0d0;
//   border-radius: 20px;
//   padding: 10px 16px;
//   border: 1px solid #f2f2f2;
//   &:focus {
//     box-shadow: rgb(4 154 173/25%) 0 0 0 0.2rem;
//     border: 1px solid #049aad;
//   }

//   min-height: calc(1.5em + 22px);
//   min-width: 320px;
//   background: #fff;
//   text-align: left;

//   transition-property: all;
//   transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
//   transition-duration: 120ms;

//   &.${selectClasses.focusVisible} {
//     outline: none;
//   }

//   &.${selectClasses.expanded} {
//     box-shadow: rgb(4 154 173/25%) 0 0 0 0.2rem;
//     border: 1px solid #049aad;
//     &::after {
//       content: '▴';
//     }
//   }

//   &.${selectClasses.disabled} {
//     background: #f2f2f2;
//     box-shadow: none;
//   }

//   &::after {
//     content: '▾';
//     float: right;
//   }
//   `,
// );

// const StyledListbox = styled('ul')(
//   ({ theme }) => `
//   font-size: 0.875rem;
//   box-sizing: border-box;
//   padding: 5px;
//   margin: 10px 0;
//   min-width: 320px;
//   max-height: 400px;
//   background: #fff;
//   border: 1px solid ${theme.palette.background.innerGray};
//   border-radius: 0.75em;
//   color: ${theme.palette.background.innerGray};
//   overflow: auto;
//   outline: 0px;
//   `,
// );

// export const StyledOption = styled(Option)(
//   ({ theme }) => `
//   list-style: none;
//   padding: 8px;
//   cursor: pointer;
//   border-radius: 4px;
//   margin: 2px 0;

//   &:last-of-type {
//     border-bottom: none;
//   }

//   &.${optionClasses.selected} {
//     background-color: ${theme.palette.background.innerGray};
//     color: ${theme.palette.primary.main};
//   }

//   &.${optionClasses.highlighted} {
//     background-color: ${theme.palette.background.innerGray};
//     color: ${theme.palette.text.primary};
//   }

//   &.${optionClasses.highlighted}.${optionClasses.selected} {
//     background-color: ${theme.palette.background.innerGray};
//     color: ${theme.palette.primary.main};
//   }

//   &.${optionClasses.disabled} {
//     color: ${theme.palette?.gray?.disabled} || 'rgba(0, 0, 0, 0.3)';
//   }

//   &:hover:not(.${optionClasses.disabled}) {
//     background-color: ${theme.palette.background.innerGray};
//     color: ${theme.palette.text.primary};
//   }
//   `,
// );

// const StyledPopper = styled(Popper)`
//   z-index: 100000;
//   width: 100%;
// `;

const StyledButton = styled('button')(
  ({ theme }) => `
  padding: 10px 16px;
  &:focus {
    box-shadow: rgb(4 154 173/25%) 0 0 0 0.2rem;
  }

  min-height: calc(1.5em + 22px);
  min-width: 320px;
  background: #fff;
  text-align: left;

  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 120ms;

  &.${selectClasses.focusVisible} {
    outline: none;
  }

  &.${selectClasses.expanded} {
    &::after {
      content: '▴';
    }
  }

  &.${selectClasses.disabled} {
    background: #f2f2f2;
    box-shadow: none;
  }

  &::after {
    content: '▾';
    float: right;
  }
  `,
);

const StyledListbox = styled('ul')(
  ({ theme }) => `
  font-size: 0.875rem;
  box-sizing: border-box;
  padding: 5px;
  margin: 10px 0;
  min-width: 320px;
  max-height: 400px;
  background: #fff;
  overflow: auto;
  outline: 0px;
  `,
);

export const StyledOption = styled(Option)(
  ({ theme }) => `
  list-style: none;
  padding: 8px;
  cursor: pointer;
  margin: 2px 0;

  &:last-of-type {
    border-bottom: none;
  }

  &.${optionClasses.selected} {
    background-color: rgba(51, 204, 204, 0.1);
    color: ${theme.palette.primary.main};
  }

  &.${optionClasses.highlighted} {
    background-color: rgba(51, 204, 204, 0.1);
    color: ${theme.palette.text.primary};
  }

  &.${optionClasses.highlighted}.${optionClasses.selected} {
    background-color: rgba(51, 204, 204, 0.1);
    color: ${theme.palette.primary.main};
  }

  &.${optionClasses.disabled} {
    color: ${theme.palette?.gray?.disabled} || 'rgba(0, 0, 0, 0.3)';
  }

  &:hover:not(.${optionClasses.disabled}) {
    background-color: ${theme.palette.background?.innerGray || '#f2f2f2'};
    color: ${theme.palette.text.primary};
  }
  `,
);

const StyledPopper = styled(Popper)`
  z-index: 100000;
  width: 100%;
`;

const StyledSelect = React.forwardRef((props, ref) => {
  const slots = {
    root: StyledButton,
    listbox: StyledListbox,
    popper: StyledPopper,
    ...props.slots,
  };

  return (
    <Select
    {...props}
      className={cx(
        'w-full rounded-lg bg-primary-light-1 px-6 py-3 font-poppins text-14 text-text-primary',
        props.className && props.className,
      )}
      ref={ref}
      slots={slots}
      slotProps={{ popper: { disablePortal: true } }}
    />
  );
});

export default StyledSelect;
